import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NotificationService } from 'app/shared/services/notification.service';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
  selector: 'app-input-item-list',
  templateUrl: './input-item-list.component.html',
  styleUrls: ['./input-item-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputItemListComponent),
      multi: true
    }]
})
export class InputItemListComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit {

  @Input() nomeCampoForm: string = null;
  @Input() listaCampos: Array<string> = [];

  constructor(
    private notification: NotificationService
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  desativarBotao() {
    const valor = this.form.get(this.nomeCampoForm) as FormControl;
    return valor.valid && valor.value !== '' ? true : false;
  }

  removerItem(index: number) {
    const lista = this.obterLista();

    if (index >= 0) {
      lista.splice(index, 1);
    }

    this.control.setValue(lista);
  }

  adicionarItem() {
    let valor = this.form.get(this.nomeCampoForm).value;
    if (valor && typeof valor === typeof new DataModel()) {
      valor = valor.complementar;
    }

    if (valor && valor !== '') {
      let lista = this.obterLista();

      if (!lista) {
        lista = new Array<any>();
      }

      if (this.existe(valor, lista)) {
        lista.push(valor);
        this.form.get(this.name).setValue(lista);
        this.form.get(this.nomeCampoForm).setValue('');
      } else {
        this.notification.alerta('Item já vinculado.');
      }
    } else {
      this.notification.alerta('Item invalido.')
    }
  }

  existe(valor: any, lista: Array<any>): boolean {
    if (typeof valor === typeof new DataModel()) {
      if (!lista.find(i => i.id === valor.id)) {
        return true;
      } else {
        return false;
      }
    } else {
      if (!lista.find(i => i === valor)) {
        return true;
      } else {
        return false;
      }
    }
  }

  listaVazia(): boolean {
    const lista = this.control.value as Array<any>;
    return lista == null || lista.length === 0 ? true : false;
  }

  listaCamposVazia(): boolean {
    return this.listaCampos.length === 0;
  }

  obterLista(): Array<any> {
    return this.control.value;
  }

  obterCampos(): Array<string> {
    return this.listaCampos;
  }
}
